
<template>
  <div>

    This is the Registration 

  </div>



</template>

<script>
import Content from "../data/content";

export default {
  name: "Registration",

  data() {
    return {
      content: Content.Registration,
    };
  },
  methods: {

  },
  mounted() {
    this.getHost(),
      this.activateCommunity(0, true)
  }

};
</script>

<style lang="scss">

</style>

